import {
  AutocompleteInput,
  ChipField,
  Datagrid,
  DateField,
  EditButton,
  Filter,
  ImageField,
  List,
  ReferenceField,
  ReferenceInput,
  ReferenceManyField,
  SingleFieldList,
  TextField,
  TextInput,
  type ListProps,
} from 'react-admin';

import { getResourceFilter } from '@/constants';

function AlbumFilter(props: ListProps) {
  return (
    <Filter {...props}>
      <TextInput
        label='Title' source='Title'
        alwaysOn
      />

      <ReferenceInput
        label='Engineers'
        source='ResourceIdentifier'
        reference='resources'
        alwaysOn
        sort={{ field: 'Name', order: 'ASC' }}
        filter={{ ...getResourceFilter() }}
      >
        <AutocompleteInput
          optionText='Name'
          label='Engineers'
          filterToQuery={(searchText) => ({ name: searchText })}
          sx={{ minWidth: 250 }}
        />
      </ReferenceInput>
    </Filter>
  );
}

function AlbumList(props: ListProps) {
  return (
    <List
      {...props}
      filters={<AlbumFilter />}
      sort={{ field: 'DateAdded', order: 'DESC' }}
      perPage={20}
    >
      <Datagrid rowClick='edit'>
        <ImageField
          source='CoverImageUrl'
          label='Album Cover'
          sx={{
            '& .RaImageField-image': {
              width: 96,
              height: 96,
              objectFit: 'cover',
              borderRadius: 2,
              display: 'block',
            },
          }}
        />
        <TextField
          source='Title' label='Title'
          sx={{ color: 'secondary.main' }}
        />
        <ReferenceManyField
          label='Artists'
          reference='album/artists'
          target='DiscographyAlbumIdentifier'
        >
          <SingleFieldList linkType={false}>
            <ReferenceField
              reference='artists'
              source='DiscographyArtistIdentifier'
              link={false}
            >
              <ChipField source='Name' />
            </ReferenceField>
          </SingleFieldList>
        </ReferenceManyField>

        <DateField source='ReleaseDate' label='Release Date' />
        <TextField source='ReleaseType' label='Release Type' />
        <TextField source='Country' label='Country' />
        <TextField source='Genre' label='Genre' />
        <TextField source='AddedBy' label='Added By' />
        <DateField
          source='DateAdded' label='Date Added'
          showTime
        />
        <DateField
          source='DateModified' label='Date Modified'
          showTime
        />
        <EditButton />
      </Datagrid>
    </List>
  );
}

export default AlbumList;
